import AppStateStore from '#/stores/AppStateStore';
import { makeAutoObservable } from 'mobx';

export default class SelfServiceStore {
    appStateStore: AppStateStore;
    constructor(initialData?: Partial<SelfServiceStore & { appStateStore: AppStateStore }>) {
        makeAutoObservable(this);
        Object.assign(this, initialData);
    }

    hydrate = (data: Partial<SelfServiceStore>): void => {
        Object.assign(this, data);
    };

    get activeReservationRef() {
        return this.appStateStore.selectedReservationRef;
    }
    get activeReservation() {
        return this.appStateStore.selectedReservation;
    }
}
